import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Anchor from '../../../UniformComponents/Anchor'
import LinkButton from '../../../UniformComponents/LinkButton'
import SurveyStore from '../SurveyStore'

@observer
export default class NavigationTabs extends Component {
    constructor(props) {
        super(props)
        const { store, showCertification } = this.props
        this.surveyStore = new SurveyStore(store, showCertification)
    }

    refresh = (e) => {
        const { activeTab, store } = this.props
        console.log('refresh', activeTab)
        if (activeTab === 'report') {
            store.reloadPage = true
        }
    }

    render() {
        const { store, activeTab } = this.props
        const navigationTabs = this.surveyStore.getNavigationTabs(activeTab)
        const { survey } = store

        return (
            <nav id="builderNavTab">
                <ul id="settings" className="survey_tabs navi">
                    <div className="childMenu">
                        {
                            navigationTabs.filter((navTab) => navTab.visible).map((tab) => (
                                <li id="menu1" className={tab.style}>
                                    <Anchor href={tab.link} onClick={tab.name === 'Reports' ? this.refresh : null}>
                                        <i className={tab.icon} />
                                        {' '}
                                        <h4>{tab.name}</h4>
                                    </Anchor>
                                    <div className={`border-bottom-div ${tab.active ? ' green-box' : ''}`} />
                                </li>
                            ))
                        }
                    </div>
                    {this.surveyStore.showRightMenuTab() && (
                        <div className="childMenu">

                            <Fragment>

                                <li id="menu1" className="settings-tab">
                                    <Anchor href={`/survey/${survey.id}/`} cssClass="settings">
                                        {i18n.t('s_tab_settings')}
                                    </Anchor>
                                    <div className={`border-bottom-div ${activeTab === undefined ? ' green-box' : ''}`} />
                                </li>

                                {!survey.closed && (
                                    <li id="menu1">
                                        <LinkButton
                                            href={survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale)}
                                            target="_blank"
                                            cssClass="primary icon-btn regular preview-btn"
                                            isExternal
                                        >
                                            <i className="fa-light fa-eye" />
                                            {' '}
                                            {i18n.t('s_tab_preview')}
                                        </LinkButton>
                                    </li>
                                )}

                            </Fragment>

                        </div>
                    )}
                </ul>
            </nav>
        )
    }
}
